import React from 'react';
import {
  Badge,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@roger/ui-components';
import type { FormTreeQuestion } from './formSchemaTypes';
import { formatSectionDropdownLabel } from './formatSectionDropdownLabel';

export function QuestionRows({
  questions,
  depth = 0,
}: {
  questions: FormTreeQuestion[];
  depth?: number;
}) {
  return (
    <>
      {questions.map(q => (
        <React.Fragment key={`${depth}-${q.qid}`}>
          <div className='flex items-center gap-3 py-1 text-sm'>
            <code
              className='text-xs text-muted-foreground font-mono w-40 shrink-0 truncate'
              style={{ marginLeft: depth * 16 }}
            >
              {q.qid}
            </code>
            <span className='flex-1 truncate'>{q.question}</span>
            {q.type && (
              <Badge variant='outline' className='text-xs shrink-0'>
                {q.type}
              </Badge>
            )}
            {q.subitems && Object.keys(q.subitems).length > 0 && (
              <Badge variant='outline' className='text-xs shrink-0'>
                subitems
              </Badge>
            )}
          </div>
          {q.subitems &&
            Object.values(q.subitems).map((subqs, index) => (
              <QuestionRows
                key={`${q.qid}-subitems-${index}`}
                questions={subqs}
                depth={depth + 1}
              />
            ))}
        </React.Fragment>
      ))}
    </>
  );
}

export function QuestionsDialog({
  sectionName,
  questions,
  onClose,
}: {
  sectionName: string | null;
  questions: FormTreeQuestion[];
  onClose: () => void;
}) {
  return (
    <Dialog
      open={sectionName != null}
      onOpenChange={open => !open && onClose()}
    >
      <DialogContent className='max-w-4xl max-h-[85vh] overflow-hidden flex flex-col'>
        <DialogHeader>
          <DialogTitle>
            {sectionName
              ? formatSectionDropdownLabel(sectionName)
              : 'Questions'}
          </DialogTitle>
          <DialogDescription>
            RogerDocs questions for this form section.
          </DialogDescription>
        </DialogHeader>
        <div className='min-h-0 flex-1 overflow-y-auto border-t pt-3'>
          <QuestionRows questions={questions} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
